import React from 'react';
import { withRouter } from 'react-router-dom';
import HeaderContent from './HeaderContent';
import { Button } from 'antd';
import { useSelector } from 'react-redux';
const ReportsContent = (props) => {
  const skills = useSelector((state) => state.skills.skills);
  const handleCustomize = () => {
    const jiraSKill = skills && skills.find((skill) => skill.key === 'jira');
    props.history.push(
      `/${props.match.params.wId}/skills/${jiraSKill.skill_metadata._id}/jira_reports?view=appHome`
    );
  };

  return (
    <div>
      <HeaderContent
        title='My Reports'
        buttonName='Customize Reports'
        buttonType='reports'
        handleCustomize={handleCustomize}
        hideCustomizeButtons={props.hideCustomizeButtons}
      />
      <div
        style={{
          paddingTop: '16px',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            width: '204px',
            height: '123px',
            borderRadius: '6px',
          }}
        >
          <img
            style={{ width: '100%', height: '100%' }}
            src='/reports1.png'
            alt='image'
          />
        </div>
      </div>
    </div>
  );
};

export default withRouter(ReportsContent);
